import MemberLectureDetails from "../../features/dashboard/members/MemberLectureDetails";

function MemberLectureDetailsDB() {
  return <MemberLectureDetails />;
}

export default MemberLectureDetailsDB;
